import React from "react";
import { useLocalization } from "gatsby-theme-i18n"
import { withPrefix } from "gatsby"
import { navigate } from "gatsby"

export default function useDisplayArticle(data, name) {
  const [article, setArticle] = React.useState({open: false, event: null, nextEvent: null});
	const [path, setPath] = React.useState((typeof window !== "undefined") ? window.location.pathname : "");
  const {locale, config} = useLocalization()
	const basePath = (config.length > 1) ? withPrefix(`/${locale}/${name}/`) : withPrefix(`/${name}/`);

	const listenToPopstate = (e) => {
		e.stopPropagation();
		if (e){
			setTimeout((basePath) => {
				window.location.pathname = basePath;
			}, 1, basePath)
		}
		if (window.location.pathname === basePath || window.location.pathname === basePath.substring(0, basePath.length - 1))
			handleDisplayArticle();
    const winPath = window.location.pathname;
    setPath(winPath);
  };

	React.useEffect(() => {
		if (typeof window === 'undefined')
			return;
		window.addEventListener("popstate", listenToPopstate);
    return () => {
      window.removeEventListener("popstate", listenToPopstate);
    };
	}, [])

	React.useEffect(() => {
		handleDisplayArticle();
	}, [path])

	const handleDisplayArticle = () => {
		if (window.location.pathname === basePath || window.location.pathname === basePath.substring(0, basePath.length - 1)){
			deleteItem();
			return;
		}
		let articleSelected = findArticleWithWindowObject(window)
		if (!articleSelected && window.location.pathname.includes(basePath))
			handleCloseItem();
		else if (window.location.pathname.includes(basePath)) {
			let fillEvent = fillArticleWithRelated(articleSelected)
			setArticleTimerOrNot({open: true, event: fillEvent});
		}
	}

	const findArticleWithWindowObject = (windObject) => {
		return (data.swapi.allBricks.find((brick) => (basePath + brick.slug === windObject.location.pathname)))
	}

	const fillArticleWithRelated = (article) => {
		let fillEvent = JSON.parse(JSON.stringify(article))
		fillEvent.related.forEach((e, i, relateds) => {
			let selectedBrick = data.swapi.allBricks.find((brick) => (brick.id === e.brick_id))
			relateds[i] = {...selectedBrick}
		})
		return (fillEvent)
	}

	const setArticleTimerOrNot = (newArticle) => {
		if (article.open === true && article.event?.id !== newArticle.event.id){
			setTimeout((e) => {
				if (basePath + e.slug === window.location.pathname)
					setArticle((state) => ({open: true, event: e}));
			}, 1000, newArticle.event)
			setArticle((state) => {
				return({open: false, event: state.event, nextEvent: newArticle.event})
			});
		} else if (article.nextEvent?.id !== newArticle.event.id){
			setArticle((state) => {
				if (state.nextEvent?.id === newArticle.event?.id)
					return {...state}
				else 
					return {...newArticle}
			});
		}
	}

	const handleClickItem = (event) => {
		window.history.pushState(event.title, event.title, basePath + event.slug);
		setPath(basePath + event.slug);
	}

	const handleCloseItem = (e) => {
		setPath(basePath);
		window.history.pushState(name, name, basePath)
	}

	const deleteItem = (e) => {
		setArticle((state) => ({open: false, event: state.event, nextEvent: undefined}));
	}
	return ([article, handleClickItem, handleCloseItem])
}